var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loan 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.668 1.875H5.91797C4.88243 1.875 4.04297 2.71447 4.04297 3.75V16.25C4.04297 17.2855 4.88243 18.125 5.91797 18.125H14.668C15.7035 18.125 16.543 17.2855 16.543 16.25V3.75C16.543 2.71447 15.7035 1.875 14.668 1.875Z",
    stroke: "#1D3557",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.293 5H14.668M10.293 7.5H14.668M9.66797 10H14.668",
    stroke: "#1D3557",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.69375 5.1087C8.69375 4.93891 8.56009 4.79999 8.39674 4.79999H5.39095C5.22759 4.79999 5.09394 4.93891 5.09394 5.1087C5.09394 5.2785 5.22759 5.41742 5.39095 5.41742H6.25229C6.68296 5.42051 7.06314 5.70452 7.19977 6.12746H5.39095C5.22759 6.12746 5.09394 6.26639 5.09394 6.43618C5.09394 6.60597 5.22759 6.7449 5.39095 6.7449H7.19977C7.15225 6.90543 7.06611 7.05361 6.95325 7.17401C6.7691 7.37159 6.51663 7.48273 6.25229 7.48581H5.39095C5.23353 7.47964 5.09988 7.6093 5.09394 7.77292C5.09097 7.85936 5.12364 7.9458 5.18601 8.00446L7.33639 10.1161C7.4552 10.2334 7.64529 10.2272 7.75519 10.1006C7.86508 9.98332 7.86211 9.79501 7.74924 9.68078C7.74627 9.67769 7.7433 9.67769 7.7433 9.67461L6.13646 8.10324H6.24932C6.67108 8.10016 7.07502 7.92419 7.37204 7.61239C7.60074 7.37776 7.75518 7.07522 7.80865 6.7449H8.39674C8.56009 6.7449 8.69375 6.60597 8.69375 6.43618C8.69375 6.26639 8.56009 6.12746 8.39674 6.12746H7.80865C7.76707 5.86506 7.6542 5.61808 7.4849 5.41742H8.39377C8.56009 5.41742 8.69375 5.2785 8.69375 5.1087Z",
    fill: "#1D3557"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLos);
export default __webpack_public_path__ + "static/media/LOS.9de2cf1db5d4712864f3dfabb07d9ae7.svg";
export { ForwardRef as ReactComponent };